import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { T2dDeletionPreview } from '@tec2date/ui-components';
import {
  BestandsknotenResponse,
  CreateBestandsknotenRequest,
  UpdateBestandsknotenRequest,
} from '../models/bestandsknoten.models';

@Injectable({ providedIn: 'root' })
export class BestandsknotenService {
  private readonly http = inject(HttpClient);

  listChildren(parentId: string | null): Observable<BestandsknotenResponse[]> {
    let params = new HttpParams();
    if (parentId !== null) {
      params = params.set('parentId', parentId);
    }
    return this.http.get<BestandsknotenResponse[]>('/bestandsknoten', { params });
  }

  getById(id: string): Observable<BestandsknotenResponse> {
    return this.http.get<BestandsknotenResponse>(`/bestandsknoten/${id}`);
  }

  create(data: CreateBestandsknotenRequest): Observable<BestandsknotenResponse> {
    return this.http.post<BestandsknotenResponse>('/bestandsknoten', data);
  }

  update(id: string, data: UpdateBestandsknotenRequest): Observable<BestandsknotenResponse> {
    return this.http.put<BestandsknotenResponse>(`/bestandsknoten/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`/bestandsknoten/${id}`);
  }

  getDeletionPreview(id: string): Observable<T2dDeletionPreview> {
    return this.http.get<T2dDeletionPreview>(`/bestandsknoten/${id}/deletion-preview`);
  }
}
